import CheckoutHeader, { CheckoutHeaderProps } from '@/features/checkout-header/CheckoutHeader';

type CheckoutViewLayoutProps = { header: CheckoutHeaderProps; wrapperClass: string } & { children: React.ReactNode };

const CheckoutViewLayout = (props: CheckoutViewLayoutProps) => {
  return (
    <div className={props.wrapperClass}>
      <CheckoutHeader {...props.header} />
      {props.children}
    </div>
  );
};

export default CheckoutViewLayout;
